import React from "react";
import Media from "react-media";
import { NotFoundPage } from "../../pages/not-found-page/NotFoundPage";
import { MobileSearchOverlay } from "./mobile/MobileSearchOverlay";

export class SearchMainComponent extends React.Component<any,any>{
    render(){
        return <div>
            {
               [<Media query="(max-width: 1064px)" render={() => {
                   return <MobileSearchOverlay {...this.props} />
               }}/>, <Media query="(min-width: 1065px)" render={() => {
                return <NotFoundPage {...this.props} />
               }}/>]
            }
        </div>
    }
}